import { FC, useMemo } from "react";
import styled from "@emotion/styled";
import {
  MDSPanelHeader,
  MDSPanelHeaderSlotName,
  MDSText,
  MDSTextVariant,
  MDSTextWeight,
} from "@/mds";
import { AudioRecordingObservable } from "@/store/audio-recordings/audio-recording-observable";

type Props = {
  recording: AudioRecordingObservable;
};

export const AudioRecordingDetailPageHeader: FC<Props> = ({ recording }) => {
  const title = useMemo(() => "Audio Recording", []);
  const accessibleLabel = useMemo(() => `Audio recording ${recording.id}`, [recording.id]);

  return (
    <HeaderWrapper>
      <MDSPanelHeader>
        <HeaderHeading slot={MDSPanelHeaderSlotName.Heading}>
          <HeaderTitle
            variant={MDSTextVariant.HeaderXl}
            weight={MDSTextWeight.SemiBold}
            aria-label={accessibleLabel}
          >
            {title}
          </HeaderTitle>
        </HeaderHeading>
      </MDSPanelHeader>
    </HeaderWrapper>
  );
};

const HeaderWrapper = styled.div`
  width: 100%;
`;

const HeaderHeading = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing[1]};
`;

const HeaderTitle = styled(MDSText)`
  display: inline-flex;
  align-items: center;
`;
